export const DataLink = {
  SharedThirdParty: {
    Share: 'データを引き継ぐ',
    AgreeTerm: '利用規約に同意して利用する',
    checkList: 'データを引き継ぎます。本当によろしいですか？',
    insert: 'OK',
    cancel: 'キャンセル',
    insertComplete: 'データの引き継ぎが完了しました',
    insertfailed:
      '引き継ぎに失敗しました。お手数おかけしますが再度お試しください',
  },

  WemexList: {
    Title: '引き継ぎデータ確認',
    PatientAge: '{0}歳',
    DispensingDateLabel: '調剤日：',
    GenderAndAgeLabel: '({0} {1})',
    DoseLabel: '× {0}',
    linkbefore: '期間指定：',
    linkafter: '引き継ぎ日指定後',
    linkfailed: '現在日以降のデータは引き継げません',
    linkstartdataover: '開始年月は終了年月以前を指定してください。',
    linkdateWave: '～',
    StartFromDateFormat: '{year}年{month}月',
  },

  PageName: {
    SharedThirdParty: 'e薬Linkでのデータ引継ぎ',
    ImageView: '画像表示',
  },
  Label: {
    EKusuriLink: {
      Share: {
        Target: '共有するお薬手帳',
      },
    },
    SharedThirdParty: {
      Explanation:
        'e薬Link機能のあるお薬手帳アプリから、最大過去1年分のデータを引き継ぐことができます。下記利用方法をご確認ください',
      HowTo: '利用方法',
      HowToText1: '1.連携元のアプリでe薬Linkのワンタイムコードを発行します ',
      HowToText2:
        '2.1で発行したワンタイムコードを画面下部「ワンタイムコード」欄に入力します ',
      HowToText3:
        '3. 連携するデータの期間を指定し、「データを引き継ぐ」をタップします ',
      Target: '共有するお薬手帳',
      OnetimeCode: 'ワンタイムコード：',
      Validation: {
        invalidInput: '無効な入力値です。',
        invalidLength: '1~200桁で入力してください。',
      },
    },
  },
  Message: {
    SharedThirdParty: {
      Result: {
        NotFoundErrorTitle: 'データの引継ぎに失敗しました。',
        NotFoundErrorText:
          '以下の原因が考えられますので、ご確認の上再度実施してください。\r\n・入力したワンタイムコードが間違っている\r\n・入力したワンタイムコードの有効期限が切れている\r\n・指定した期間に引継ぎできるお薬が存在しない',
      },
    },
  },
};
